module.exports = __webpack_public_path__ + "img/files-upload-success.9fe05c85.png";